import { create } from 'zustand'

interface LayoutState {
  isCollapsed: boolean
  isMobileOpen: boolean
  toggleCollapse: () => void
  toggleMobileMenu: () => void
  closeMobileMenu: () => void
}

export const useLayoutState = create<LayoutState>((set) => ({
  isCollapsed: false,
  isMobileOpen: false,
  toggleCollapse: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
  toggleMobileMenu: () => set((state) => ({ isMobileOpen: !state.isMobileOpen })),
  closeMobileMenu: () => set({ isMobileOpen: false }),
}))